var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28189 2.48154C6.28189 2.48154 7.50804 1.85254 8.43458 1.85254C9.17221 1.87206 9.8891 2.07697 10.5151 2.44365V8.30863C9.86526 8.015 9.15569 7.85881 8.43458 7.85254C7.56407 7.88459 6.71033 8.09243 5.92888 8.46254C5.21348 8.8668 4.40837 9.10181 3.57992 9.14821C1.84611 9.14821 1.15259 8.16087 1.15259 8.16087L1.15259 2.50054C1.15374 2.50155 1.84756 3.11054 3.57992 3.11054C4.5175 3.09265 5.43968 2.87798 6.28189 2.48154ZM1.15259 1.16087L1.15259 1.16087L1.15259 1.14819H0.112305V15.1482H1.15259L1.15259 9.40621C1.15259 9.40621 1.84611 10.1105 3.57992 10.1105C4.5175 10.0927 5.43968 9.87799 6.28189 9.48154C6.28189 9.48154 7.50804 8.85254 8.43458 8.85254C9.28623 8.85994 10.1218 9.07646 10.8619 9.48154L11.5554 9.92187V8.92187L11.5554 8.92186V2.92187L11.5554 2.92187V1.92187L10.8619 1.48154C10.1218 1.07646 9.28623 0.859941 8.43458 0.852539C7.56407 0.884593 6.71033 1.09243 5.92888 1.46254C5.21348 1.8668 4.40837 2.10181 3.57992 2.14821C1.84772 2.14821 1.15387 1.1627 1.15259 1.16087Z",
    fill: "#757677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.fa3654338c102dfb24f8f7ddfbc38813.svg";
export { ForwardRef as ReactComponent };